<template v-bind:is="currentTabComponent" >

    <spinner v-if="!loaded" ></spinner>

    <div class="page container" v-else-if="loaded" >
        
        <div class="mt-3 d-none" >
            <ul class="horizontal-menu " > 
                <li>  <router-link :to="{name: 'Integrations'}" class="not-active pl-0" > <font-awesome-icon icon="arrow-circle-left" ></font-awesome-icon> Back </router-link>  </li>
            </ul>
        </div>
        
        <div class="row position-relative mt-3" >
            
            <span v-if="editable" class="position-absolute right-0 mt-2 mr-4" >
                <b-button @click="update" variant="primary" class="btn btn-sm" > <font-awesome-icon :icon="['far', 'save']" class="mr-1" />  Save </b-button>    
                <b-button @click="edit" v-if="type == 'edit'" variant="outline-secondary" class="btn btn-sm" > <font-awesome-icon :icon="['fa', 'times']" class="mr-1" />  Cancel </b-button>    
            </span>
            
            <b-dropdown v-if="type == 'edit' && !editable " size="sm" html='Actions <svg aria-hidden="true" class="atlass-icon icon-chevron-down fill-white" height="14" width="14" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M13.591 5.293a1 1 0 0 1 1.416 1.416l-6.3 6.3a1 1 0 0 1-1.414 0l-6.3-6.3A1 1 0 0 1 2.41 5.293L8 10.884z" fill-rule="evenodd"></path></svg>' variant="primary" right split-variant class="font-size-14 position-absolute right-0 mt-2 mr-4">
                 <b-dropdown-item-button @click="edit"  >Edit</b-dropdown-item-button>
                <b-dropdown-item-button v-if="data.Status" @click="toggleSwitch( 'Status', false )"   >Deactivate</b-dropdown-item-button>
                <b-dropdown-item-button v-else-if="!data.Status" @click="toggleSwitch( 'Status', true )"  >Activate</b-dropdown-item-button>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item-button variant="danger" @click="preventDelete()" >Delete</b-dropdown-item-button>
            </b-dropdown>

            
            <div class="col-12 text-center" v-if="type == 'add' "  >

                <div v-if="!integrating"  class="col-12 mt-5" >
                    <div class="text-center font-weight-bold h1 pt-5" > Connect to your TikTok account </div>
                    
                    <button class="btn btn-primary btn-lg border-radius mt-5 cursor-pointer" @click="getAuthToken()" > Connect </button>
                </div>
                
                <div v-else-if="integrating"  class="col-12 mt-4" >
                    <p class="text-center font-weight-bold" > Setting everything up. Might take a while... </p>
                    <spinner type="small" ></spinner>
                </div>
                
                
            </div>
            
            <b-card no-body class="col-12  atlass-tabs" v-if="type == 'edit' " >
                <b-tabs card  >
                    
                    <b-tab @click="goBack" class="p-0" >
                        <template #title>
                            <font-awesome-icon icon="arrow-circle-left" ></font-awesome-icon> Back
                        </template>
                    </b-tab>
                    
                    <b-tab title="Overview" class="p-0 " active>
                        <b-card-text>
                            
                            <spinner v-if="!tabloaded" ></spinner>
                            
                            <div v-if="tabloaded"  >
                                
                                <!-- GOOGLE ACCOUNT SECTION -->
                                <div class="w-100" >
                                    
                                    <div class="col-12 border-bottom-gray pb-2 mb-4 " >
                                        <span class="d-inline-block line-height-31" > <h2 class="h2 font-weight-bold line-height-31" > TikTok Ads Account </h2> </span>
                                    </div>
                                    
                                    <div class="col-12 mt-4" >
                                        <div class="row" >

                                            <div class="col-12 " >

                                                <div class="mt-1" >
                                                    
                                                    <b-form  class="atlass-form col-12 mt-3 " >
                                                        
                                                     <div class="col-12 form-group" >
                                                         <b-form-group >
                                                            <label> Integration Name: </label>
                                                            <span v-if="!editable" class="font-weight-bold" > {{data.Name}} </span>
                                                            <b-form-input v-else-if="editable" id="NameInput" 
                                                                type="text"
                                                                v-model="data.Name"
                                                                required
                                                            placeholder="Name">
                                                            </b-form-input>
                                                        </b-form-group>
                                                    </div>

                                                     
                                                    <div class="col-12 form-group"  >
                                                         <b-form-group >
                                                            <label> Status: </label>
                                                            <span v-if="!editable" >
                                                                <b v-if="data.Status == 1" > Active </b>
                                                                <b v-else-if="data.Status == 0"  > Inactive </b>
                                                            </span>

                                                            <div v-else-if="editable" >
                                                                <b-form-checkbox v-model="data.Status" name="check-button" class="cursor-pointer d-inline-block" switch > </b-form-checkbox>
                                                                <span v-if="data.Status" > Active </span>
                                                                <span v-else-if="!data.Status" > Inactive </span>
                                                            </div>

                                                        </b-form-group>
                                                    </div>

                                                    <div class="col-12 form-group" >
                                                         <b-form-group >
                                                            <label> Created at: </label>
                                                            <span class="font-weight-bold" > {{ formatData( data.datetime ) }} </span>
                                                        </b-form-group>
                                                    </div>

                                                        
                                                </b-form>

                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    
                                </div>
                                
                                <!-- INTEGRATION SECTION -->
                                <div class="w-100 mt-5" >
                                    
                                    <div class="col-12 border-bottom-gray pb-2 mb-4 " >
                                        <span class="d-inline-block line-height-31" > <h2 class="h2 font-weight-bold line-height-31" > Integration Details </h2> </span>
                                        <span class="d-inline-block line-height-31 float-right" > 
                                            <font-awesome-icon :icon="['fas', 'check-circle']" v-if="data.Status" class="font-size-16 color-green" /> 
                                            <span v-if="data.Status" > Active </span>
                                            <span v-else-if="!data.Status" > Inactive </span>
                                        </span>
                                    </div>

                                    <div class="col-12 mt-3" >
                                        <div class="row" >
                                            <div class="col-12 col-md-10" >
                                                <h2 class="h3 font-weight-bold line-height-31" > Attribute campaigns </h2>
                                                <p class="mt-1" >
                                                    This will pull all ads from your enabled ad accounts in order to render the analyze dashboard.
                                                </p>
                                            </div>
                                            <div class="col-12 col-md-2 text-right" >
                                                <b-form-checkbox v-model="data.settings.attribute_campaigns" name="check-button" @change="toggleSwitch( 'attribute_campaigns', data.settings.attribute_campaigns )" class="cursor-pointer d-inline-block" switch > </b-form-checkbox>
                                                <span v-if="data.settings.attribute_campaigns" > Active </span>
                                                <span v-else-if="!data.settings.attribute_campaigns" > Inactive </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12 mt-5 d-none" >
                                        <div class="row" >
                                            <div class="col-12 col-md-10" >
                                                <h2 class="h3 font-weight-bold line-height-31" > Offline conversions </h2>
                                                <p class="mt-1" >
                                                    This action will send the conversions back to Facebook as offline conversions. <br>
                                                    
                                                    <b-alert show variant="danger">
                                                        <b>Important!</b>
                                                        Please don't activate this until we make sure tracking and attribution is confirmed.
                                                    </b-alert>
                                                </p>
                                            </div>
                                            <div class="col-12 col-md-2 text-right" >
                                                <b-form-checkbox v-model="data.settings.offline_conversions" name="check-button" @change="toggleSwitch( 'offline_conversions', data.settings.offline_conversions )" class="cursor-pointer d-inline-block" switch > </b-form-checkbox>
                                                <span v-if="data.settings.offline_conversions" > Active </span>
                                                <span v-else-if="!data.settings.offline_conversions" > Inactive </span>
                                            </div>
                                        </div>
                                    </div>
                                    
                                </div>
                                <!-- INTEGRATION SECTION -->
                                
                            </div>
                            
                        </b-card-text>
                    </b-tab>
                    
                    <b-tab title="Ad Accounts"  @click="getAdAccounts()" class="p-0 "  >
                        
                        <spinner v-if="!tabloaded" ></spinner>
                        
                        <div v-if="tabloaded"  >
                            
                            <div class="col-12 border-bottom-gray pb-2 mb-4" >
                                <span class="d-inline-block line-height-31" > <h2 class="h2 line-height-31" > Connected Ad accounts </h2> </span>

                                <button type="button"  class="btn btn-outline-primary btn-sm float-right d-none"   @click="importAdAccounts( )"
                                    v-if=" data.refresh_token != '' "
                                >
                                    Reimport Ad Accounts
                                </button>

                            </div>
                            
                            <div class="col-12" >
                                
                                <div class="row" >
                                    <div class="col-12" >
                                        <b-input-group>
                                            <b-form-input v-model="filter" placeholder="Search Ad Accounts" class="search-input atlass-input-borderless" />
                                            <font-awesome-icon icon="times-circle" @click="filter = ''" class="reset-filter" v-bind:class="{ 'd-none' : !filter }" >Clear</font-awesome-icon>
                                        </b-input-group>
                                    </div>
                                </div>
                                
                                <vue-good-table
                                v-if="AdAccounts.length > 0"
                                :columns="columns"
                                :rows="AdAccounts"
                                styleClass="vgt-table atlass-datatable mb-3"
                                :search-options="{ enabled: true, externalQuery: filter }"
                                :pagination-options="{ 
                                    enabled: true,
                                    perPage: 15,
                                    perPageDropdown: [50, 100],
                                    ropdownAllowAll: true,
                                    nextLabel: 'next',
                                    prevLabel: 'prev',
                                    rowsPerPageLabel: 'Ad accounts per page',
                                    ofLabel: 'of',
                                    pageLabel: 'page', // for 'pages' mode
                                    allLabel: 'All',
                                }"
                                :selectOptions="{
                                    enabled: false,
                                    selectOnCheckboxOnly: false, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                  }"
                                
                                 >

                                <template slot="table-row" slot-scope="props">
                                    <span v-if="props.column.field == 'Status'">
                                        
                                        <b-form-checkbox v-model="props.row.Status" name="check-button" class="cursor-pointer d-inline-block" switch    @change="changeAdAccountStatus(props.row)" > </b-form-checkbox>
                                        <span v-if="props.row.Status" >  </span>
                                        <span v-else-if="!props.row.Status" >  </span>
                                        
                                    </span>
                                    <span v-else-if="props.column.field == 'Ads'">
                                        
                                        <a @click="logout()" class="cursor" > <font-awesome-icon icon="list"  /> </a>
                                        
                                    </span>
                                    <span v-else  >
                                        {{props.formattedRow[props.column.field]}}
                                    </span>
                                </template>

                            </vue-good-table>
                                
                            </div>
                            
                        </div>
                        
                    </b-tab>
                    
                </b-tabs>
            </b-card>

            
        </div>
       
    </div>
</template>

<script>

import firebase from "firebase";
import { mapGetters, mapState } from 'vuex'
import Cookies from 'js-cookie'
import axios from 'axios'
import helper from '@/helpers/helpers.js';
    
export default {
    name: 'TIKTOK',
    components:{
        
    },
    props: {
        ID:{
            type: [String]
        }
    },
    data: function(){
        return {
            loaded: false, 
            APP_ID: '7067523500314984449',
            APP_SECRET: '7bfa839955c6a7b4e40a07deeda8a1f0902cb30b',
            data:{
                "APP": "TIKTOK",
                Name: "TikTok Integration",
                Tag: "tiktok",
                "Type" : 'ads',
                userInfo: {},
                access_token: '',
                Status: true,
            },
            AdAccounts: [],
            type: 'add',
            editable: false,
            tabloaded: false,
            allowTestIntegration: false,
            integrating: false,
            
            filter: '',
            columns: [
                {
                    label: 'Name',
                    field: 'name',
                    tdClass: 'font-weight-bold',
                },
                {
                    label: 'ACCOUNT ID',
                    field: 'id',
                    tdClass: 'font-weight-bold',
                },
                /*
                {
                    label: 'ACCOUNT ID',
                    field: 'account_id'
                    //field: this.renderTag
                },
                */
                {
                    label: 'CURRENCY',
                    field: 'currency',
                },
                {
                    label: 'TIMEZONE',
                    field: 'display_timezone',
                },
                {
                    label: 'STATUS',
                    field: 'Status',
                    sortable: false,
                    tdClass: 'text-center',
                    thClass: 'text-center',
                },
                {
                    label: 'ADS',
                    field: 'Ads',
                    sortable: false,
                    tdClass: 'text-center',
                    thClass: 'text-center',
                },
            ],
        }
    },
    beforeCreate: function () {
    },
    created: function () {
        
    },
    mounted: function () {
        
        //console.log(this.ID)
        if( this.ID == 'new' ){
            this.loaded = true
            this.editable = true
            
            let urlParams = new URLSearchParams(window.location.search);
            if( urlParams.has('auth_code') ){
                let auth_code = urlParams.get('auth_code')   
                //console.log(code)
                
                this.getAccessToken( auth_code )
                .then((response)=>{

                    console.log(response)
                    if( response ){
                        let access_token = response.data.data.access_token
                        let advertiser_ids = response.data.data.advertiser_ids

                        console.log( access_token )
                        this.data.access_token = access_token
                        this.data.advertiser_ids = advertiser_ids

                        //GET TIKTOK ADVERTISER INFO
                        /*
                        this.getUserInfo( access_token )
                        .then((response)=>{

                            let userInfo = response.data.data
                            this.data.userInfo = userInfo

                            //SAVE INTEGRATION
                            this.integrating = true
                            this.saveIntegration()
                            //SAVE INTEGRATION

                        }) //END getUserInfo
                        */
                        //GET TIKTOK ADVERTISER INFO

                        //SAVE INTEGRATION
                        this.integrating = true
                        this.saveIntegration()
                        //SAVE INTEGRATION
                    }
                        

                }) //END getAccessToken
                

            }else{
                //this.getAuthToken()
            }
            
        }else{
            this.get_data( this.ID );
        }
        
    },
    beforeDestroy() {
    },
    methods: {
        
        refreshToken(){
            
            this.$gapi.refreshToken()
            .then((result)=>{
                console.log(result)
            })
            
        },

        getAccessToken( auth_code ){
                        
            let payloadData = { 
                    "app_id": this.APP_ID,
                    "secret": this.APP_SECRET,
                    "auth_code": auth_code,
                } 
            
            let headers = { 
                    'Access-Control-Allow-Headers': '*', 
                    'Access-Control-Allow-Origin': '*',  
                    'Content-Type': 'application/json' 
                }
            
            return axios({ 
                method: 'post',
                //url: 'https://sql.theatlass.com/google-api/getAccessToken.php',
                //url: 'http://192.168.64.4/theatlass.com/sql/tiktok/access_token.php',
                url: 'https://sql.theatlass.com/tiktok/access_token.php',
                //url: 'https://business-api.tiktok.com/open_api/v1.2/oauth2/access_token/',
                headers: headers,
                data: payloadData
            })
            .then(resp => {    
                if( resp.status == 200 && resp.data.message == 'OK' ){
                    return resp
                }else{
                    return false
                    this.$toast.error({
                        title:'Error',
                        message:  'Could not fetch access Token'
                    })
                }
            })
            .catch(error => {
                
                console.log(error)
                this.$toast.error({
                    title:'Error',
                    message:  'Error while fetching sources. Please reach out to us!'
                })

            }); //end axios 
            
        },

        getAdvertiserInfo( access_token, advertiser_ids ){

            let headers = { 'Content-Type': 'application/json' }
            
            return axios({ 
                method: 'post',
                //url: 'https://sql.theatlass.com/api/stats.php?s='+searchPhrase,
                //url: 'https://192.168.64.4/theatlass.com/sql/tiktok/getAdvertiserInfo.php', ///advertiser/info/
                url: 'https://sql.theatlass.com/tiktok/getAdvertiserIDs.php', ///advertiser/info/
                //url: 'https://business-api.tiktok.com/open_api/v1.2/advertiser/info/', ///advertiser/info/
                headers: headers,
                data: { 
                    "access_token": access_token,
                    "app_id": this.APP_ID,
                    "secret": this.APP_SECRET,
                    "advertiser_ids": advertiser_ids,
                } 
            })
            .then(resp => {    
                 if( resp.status == 200 && resp.data.message == 'OK' ){
                    return resp
                }else{
                    return false
                    this.$toast.error({
                        title:'Error',
                        message:  'Could not fetch user info'
                    })
                }
            })
            .catch(error => {
                
                console.log(error)
                this.$toast.error({
                    title:'Error',
                    message:  'Error while fetching sources. Please reach out to us!'
                })

            }); //end axios 
            
        },

        getAuthToken( ){
            
            //let url = 'https://accounts.google.com/o/oauth2/v2/auth/oauthchooseaccount?response_type=code&access_type=offline&include_granted_scopes=true&client_id=1022726355435-777qvs0mukg5bb56b6p52u14h39smgvk.apps.googleusercontent.com&scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fadwords&redirect_uri=http://localhost:3000/app/setup/integrations/google-adwords/new'
          
            //let url = 'https://accounts.google.com/o/oauth2/v2/auth/oauthchooseaccount?response_type=code&access_type=offline&include_granted_scopes=true&client_id=1022726355435-777qvs0mukg5bb56b6p52u14h39smgvk.apps.googleusercontent.com&scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fadwords&redirect_uri=https%3A%2F%2Fsql.theatlass.com%2Fgoogle-api%2Fcallback.php'
            
            let redirectURI = process.env.ROOT_DOMAIN + '/app/setup/integrations/tiktok/new'
            
            let url = 'https://accounts.google.com/o/oauth2/v2/auth?response_type=code&access_type=offline&prompt=consent&include_granted_scopes=true&client_id=1022726355435-777qvs0mukg5bb56b6p52u14h39smgvk.apps.googleusercontent.com&scope=https://www.googleapis.com/auth/adwords%20https://www.googleapis.com/auth/userinfo.profile%20email&redirect_uri='+redirectURI
            
            url = 'https://192.168.64.4/theatlass.com/sql/tiktok/auth.php?app_id=1234563538718072834&state= your_custom_params&rid=m33xyaj1fp&redirect_uri='+redirectURI
            
            redirectURI = 'https://theatlass.com/app/setup/integrations/tiktok/new'
            url = 'https://ads.tiktok.com/marketing_api/auth?app_id=7067523500314984449&state=your_custom_params&redirect_uri='+redirectURI+'&rid=1wbx5bqwtty'
            
            //window.open(url, '_blank').focus();
            window.location.replace( url );
            
            
        },
        
        saveIntegration(){
            
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )

            let document = this.data
            document.datetime = Math.round(+new Date()/1000)

            if( this.type == 'add' ){
                
                let settings = {}
                settings.attribute_campaigns = true
                settings.offline_conversions = false

                document.Name = "Tiktok Integration"
                
                document.settings = settings
                                
                let ref = this.$firebase.firestore().collection('organizations/'+orgID+'/integrations')

                return ref.add( document )
                 .then((result)=>{
                    let docID = result.id
                    
                    //console.log(docID)
                    
                    this.importAdAccounts( docID )
                    
                    //this.successfullRedirect( docID )

                    this.editable = false

                })

            }
            
        },
        
        successfullRedirect( docID ){
            
            this.$toast.success({
                title:'Success',
                message: 'Integration successful'
            })   

            this.$router.push({
                name: 'TIKTOK',
                params: { ID: docID }
            }); 

            this.integrating = false
            this.get_data( docID );
            
        },
        
        //EDIT
        
        importAdAccounts( docID = null ){
            
            let redirect = true
            if( docID == null ){
                let redirect = false
                docID = this.data.docID
            }
            
            console.log(this.data)
            
            this.getAdvertiserInfo( this.data.access_token, this.data.advertiser_ids )
            .then((response)=>{
                
                console.log(response)
                if( response ){
                    
                    let advertisers = response.data.data

                    this.AdAccounts = advertisers

                    this.AdAccounts.forEach((document, i)=>{
                        //SAVE
                        document.datetime = Math.round(+new Date()/1000)
                        document.Status = true

                        let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
                        let ref = this.$firebase.firestore().collection('organizations/'+orgID+'/integrations/'+docID+'/AdAccounts').add( document )

                        return ref
                        .then((result)=>{

                            if( i == this.AdAccounts.length - 1 || ( this.AdAccounts.length == 0 ) ){

                                if( redirect ){

                                    this.successfullRedirect( docID )

                                }else{
                                    this.$toast.success({
                                        title:'Success',
                                        message: 'Import successful'
                                    }) 
                                    this.integrating = false
                                }

                            }

                        })
                        //SAVE
                    }) //this.AdAccounts.forEach

                }else{
                    if( redirect ){
                        this.successfullRedirect( docID )
                    }
                    this.integrating = false
                }
                
            })
                
            
        },
        
        processCustomers( customers ){
            
            let AdAccounts = []
            customers.forEach((customer)=>{
                
                if( !customer.info.error ){
                    
                    if( customer.manager == true ){
                        
                        customer.clients.forEach((client)=>{
                            
                            let obj = {
                                ResourceName: client.customerClient.resourceName,
                                AccountID: client.customerClient.id,
                                Name: client.customerClient.descriptiveName,
                                Currency: client.customerClient.currencyCode,
                                Timezone: client.customerClient.timeZone,
                                Status: true,
                                datetime: Math.round(+new Date()/1000)
                            }
                            
                            if( !client.customerClient.manager ){
                                obj.managedBy = customer.customerID
                            }
                            
                            if( obj.Name == undefined ){
                                obj.Name = "Account "+client.customerClient.id
                            }
                            
                            if( AdAccounts.find(item => item.AccountID === obj.AccountID ) == undefined ){
                                AdAccounts.push( obj )
                            }
                                
                            

                            
                        })
                        
                    }else{
                        
                        let obj = {
                            ResourceName: customer.info.resourceName,
                            AccountID: customer.info.id,
                            Name: customer.info.descriptiveName,
                            Currency: customer.info.currencyCode,
                            Timezone: customer.info.timeZone,
                            Status: true,
                            datetime: Math.round(+new Date()/1000)
                        }
                        
                        if( obj.Name == undefined ){
                            obj.Name = "Account "+customer.info.resourceName
                        }
                        
                        if( AdAccounts.find(item => item.AccountID === obj.AccountID ) == undefined ){
                            AdAccounts.push( obj )
                        }
                    }
                    
                }
                
                        
            })
            
            //console.log( AdAccounts )
            return AdAccounts
            
        },
        
        goBack(){
            this.$router.push({
                name: "Integration",
                params: { APP: 'TIKTOK' }
            });
        },
        
        get_data( ID ){
          
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            
            const db = this.$firebase.firestore();
            
            var ref = db.collection('organizations/'+orgID+'/integrations').doc( ID )
                                    
            return ref.get()
                .then((snapshot) => {
                    if( !snapshot.empty ){
                        //console.log(snapshot.data())
                        this.data = snapshot.data()
                        this.data.docID = snapshot.id
                        
                        //this.importAdAccounts()
                        
                        this.type = 'edit'
                        this.allowTestIntegration = true
                        this.editable = false
                        
                    }else{
                        console.log("No integration set")
                    }
                        
                    this.loaded = true;
                    this.tabloaded = true;
                })
          
        },
        
        getAdAccounts(  ){
            
            this.tabloaded = false
            
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )            
            var ref = this.$firebase.firestore().collection('organizations/'+orgID+'/integrations/'+this.ID+'/AdAccounts')
                                    
            return ref.get()
            .then((results) => {
                
                this.AdAccounts = [];
                results.forEach((account)=>{
                    let adaccount = account.data()
                    adaccount.docID = account.id
                    this.AdAccounts.push( adaccount )
                })
                this.tabloaded = true
                
            })
            
        },
        
        formatData(unix){
            //console.log(unix)
            return this.$moment.unix(unix).format( 'MMM D YYYY, HH:mm' )
        },
        edit(){
            this.editable = !this.editable
        },
        
        submit(){
            
            this.loaded = false
            
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            const db = this.$firebase.firestore();
            
            let document = {
                    "APPKEY": orgID,
                    "APP": "WOOCOMMERCE",
                    "Name" : this.data.Name,
                    "Type" : 'eccomerce',
                    "Tag" : this.data.Tag,
                    "ConsumerKey": this.data.ConsumerKey,
                    "ConsumerSecret": this.data.ConsumerSecret,
                    "Woocommerce_url": this.data.Woocommerce_url,
                    "Status": this.data.Status
                }
            
            //console.log(document)
            
            if( this.type == 'add' ){
                let settings = {}
                settings.attribute_campaigns = true
                settings.sync_leads = false

                document.settings = settings
                
                document.datetime = Math.round(+new Date()/1000)
                    
                let ref = db.collection('organizations/'+orgID+'/integrations')
                
                return ref.add( document )
                 .then((result)=>{
                    
                    this.get_data(result.id)
                    
                    this.$toast.success({
                        title:'Success',
                        message: 'Integration successfully created'
                    })
                    
                    this.loaded = true
                    
                })
                
            }else{
                
                document.last_update = Math.round(+new Date()/1000)
                    
                let ref = db.collection('organizations/'+orgID+'/integrations').doc( this.data.docID )
                
                return ref.set( document, { merge: true } )
                .then((result)=>{
                    
                    this.$toast.success({
                        title:'Success',
                        message: 'Changed saved '
                    })
                    
                    this.loaded = true
                    
                })
                
            }

            
        },
        
        changeAdAccountStatus( account ){
            
            account.Status = !account.Status
            console.log( account )
            
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            this.$firebase.firestore().collection('organizations/'+orgID+'/integrations/'+this.data.docID+'/AdAccounts').doc( account.docID )
                .update( { Status: account.Status } )
                .then((result)=>{
                    this.$toast.success({
                        title:'Success',
                        message: 'Ad account updated'
                    })
                })
            
            
        },
        
        update(){
            
            this.loaded = false
            
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            const db = this.$firebase.firestore();
            
            let document = this.data
            document.last_update = Math.round(+new Date()/1000)

            let ref = db.collection('organizations/'+orgID+'/integrations').doc( this.data.docID )

            return ref.set( document, { merge: true } )
            .then((result)=>{

                this.$toast.success({
                    title:'Success',
                    message: 'Changed saved '
                })

                this.loaded = true
                this.editable = false

            })
            
        },
        
        testIntegration(){
            let params = Cookies.get('user-token')
            //let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            
            let data = { "APPKEY": helper.getLoggedInOrganization( this.$store.getters.isAdmin ), "integrationID": this.data.docID }
            //let data = JSON.stringify( this.newOrg )/
            let headers = { 'Access-Control-Allow-Headers': '*', 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json; charset=utf-8', "X-Auth": params }
            
            axios({ method: 'POST', url: process.env.ROOT_API+'/integrations/mailchimp/test', headers: headers, data: data })
                .then(resp => {
                                
                if( resp.status == 200 ){
                    let r = resp.data;
                    
                    this.$toast.success({
                        title:'Success',
                        message: r.health_status
                    })
                }
                    
                
            }).catch(error => {
                console.log(error)
            }); //end axios 
            
        },
        
        toggleSwitch( field, value ){
            
            let document = {}
            let update = true;
            
            console.log(this.data)
            
            if( field == 'Status' ){
                this.data.Status = value
                document.Status = value
            }else if( field == 'sync_leads' ){
                let settings = {}
                settings.sync_leads = this.data.settings.sync_leads
                document['settings.sync_leads'] = !this.data.settings.sync_leads
                
                if( !this.data.settings.sync_leads ){
                    update = false
                }else{
                    update = true
                }
                
            }else if( field == 'attribute_campaigns' ){
                document['settings.attribute_campaigns'] = !this.data.settings.attribute_campaigns
            }else if( field == 'audience_ID' ){
                if( this.data.audience_ID == '' ){
                    this.data.settings.sync_leads = false
                }
                document['settings.sync_leads'] = this.data.settings.sync_leads
                document.audience_ID = this.data.audience_ID
            }
            
            document.last_update = Math.round(+new Date()/1000)
            
            if( update ){
                //UPDATE FIRESTORE
                let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
                const db = this.$firebase.firestore();
                let ref = db.collection('organizations/'+orgID+'/integrations').doc( this.data.docID )

                return ref.update( document )
                .then((result)=>{
                    this.$toast.success({
                        title:'Success',
                        message: 'Changed saved '
                    })
                })
            }
            
        },//end toggleSwitch
        
        logout(){
            
        },
        
        preventDelete( ){
            
            this.$swal({
                title: 'Are you sure?',
                text: 'This cannot be undone and the conversion will be deleted as well',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.value) { 
                    
                    this.delete( );
                    
                }
            })
            
        },        
        delete: function( ){
            
            this.loaded = false
            
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            
            const db = firebase.firestore();
            
            let ref = db.collection('organizations/'+orgID+'/integrations').doc( this.ID )
            return ref.delete()
            .then(function(){

                 this.$toast.success({
                    title: 'Success',
                    message: 'Integration deleted'
                })

                setTimeout(function(){ 
                    this.loaded = true
                    this.$router.push({
                        name: 'Integrations'
                    }); 
                }.bind(this), this.timeout );

            }.bind(this))
            .catch(function(error){

                //console.error("Error updating document: ", error);
                this.$toast.error({
                    title: 'Error',
                    message: "Something went wrong: "+error
                })

                this.loaded = true

            }.bind(this))
            
        },
        
    },
    watch: {

    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped >

    .field{
        margin: 5px 0;
    }
    
    .span-width{
        min-width: 180px;
        max-width: 240px;
        display: inline-block;

    }
    
    .tab-pane{
        margin-top: 2rem;
    }
    
</style>



// WEBPACK FOOTER //
// src/templates/setup/integrations/TIKTOK.vue